import breakpoints from "../utils/breakpoints";
import useDocumentSize from "./useDocumentSize";

function useIsMobile() {
  const { width } = useDocumentSize();
  const { tablet } = breakpoints;
  return width < tablet;
}
export default useIsMobile;
